"use strict";

export class Header {
  constructor() {
    //
  }
}
